"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A custom error that encapsulates the upstream server response.
 *
 * see also https://stackoverflow.com/questions/31626231/custom-error-class-in-typescript
 */
var ContentApiError = /** @class */ (function (_super) {
    __extends(ContentApiError, _super);
    function ContentApiError(upstream, message, statusCode, responseBody) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, ContentApiError.prototype);
        _this.statusCode = statusCode;
        _this.responseBody = responseBody;
        return _this;
    }
    return ContentApiError;
}(Error));
exports.default = ContentApiError;
//# sourceMappingURL=content-api.error.js.map